<template>
    <div class="container-ws mt-2" id="tabWhatsApp">
      <section>
        <div class="d-flex align-items-center mb-2" v-if="!onlyRequest">
          <b-form-checkbox
            v-if="editWhatsApp"
            switch
            class="checkbox-switch switch-webhook checkbox-company"
            v-model="form.activated">
            <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
          </b-form-checkbox>
          <div v-else>
            <span class="table_dot--ws mr-50" :class="getStatusClass(form.activated)"></span>
            <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
          </div>
        </div>
        <b-form-group label="Tipo de plan de notificaciones" v-slot="{ ariaDescribedby }">
          <b-form-radio v-model="notificationPlanType" :aria-describedby="ariaDescribedby" name="ws-radios" value="basic" :disabled="disabledFields.loading">Básico</b-form-radio>
          <b-form-radio v-model="notificationPlanType" :aria-describedby="ariaDescribedby" name="ws-radios" value="custom" disabled class="mt-50 custom-disabled-field-ws">Personalizado</b-form-radio>
        </b-form-group>
        <div class="d-flex container-statuses">
            <b-form-group
              v-slot="{ ariaDescribedby }"
              :disabled="disabledFields.trackingDisabled"
              label="Estados de notificación tracking"
              class="mt-3"
              :class="disabledFields.trackingDisabled ? 'opacity-statuses-incidence' : ''"
            >
                <p class="custom-color-text-ws p-0 m-0 ml-50">Estos estados serán únicamente informativos para el usuario.</p>
                <p class="custom-color-text-ws p-0 m-0 ml-50">Luego de seleccionar algún estado de tracking se habilitarán los de incidencia.</p>
                <b-form-checkbox-group class="mt-2 ml-50" id="checkboxWs" v-model="form.notificationsActive" :options="listNotifications"
                    :aria-describedby="ariaDescribedby" name="flavour-1" stacked>
                </b-form-checkbox-group>
            </b-form-group>
            <div class="vertical-line mt-3 ml-3 mr-3"></div>
            <b-form-group
              :disabled="disabledFields.incidenceDisabled"
              class="mt-3"
              :class="disabledFields.incidenceDisabled ? 'opacity-statuses-incidence' : ''"
            >
                <template #label>
                    <span
                        v-b-tooltip.hover
                        :title="disabledFields.notNotificationsActive ? $t('Debe marcar al menos un estado de tracking') : ''"
                    >
                        Estados de notificación incidencia
                    </span>
                    <feather-icon
                        class="alert-customize-ws"
                        icon="AlertCircleIcon"
                        size="15"
                        v-b-tooltip.hover
                        :title="$t('Únicamente para envíos distribución que tengan tickets')"
                    />
                </template>
                <p class="custom-color-text-ws p-0 m-0 ml-50">Estos estados generarán tickets y conversación del usuario mediante whatsApp.</p>
                <p class="custom-color-text-ws p-0 m-0 ml-50">Debe activar al menos un estado de notificación tracking (sección previa).</p>
                <b-form-checkbox
                    v-model="form.selectIncidentNotifications"
                    value="incidence"
                    class="mt-2 ml-50 custom-disabled-field-ws"
                >
                Seleccionar estados incidencia:
                </b-form-checkbox>
                <ul>
                    <li v-for="(stateIncidence, index) in statesOfIncidence" :key="index" class="mt-50 ml-50">{{ stateIncidence }}</li>
                </ul>
            </b-form-group>
        </div>
        <b-button
          v-if="disabledFields.fields"
          variant="outline-warning"
          class="btn btn-custom-ws ml-1"
          :disabled="disabledFields.editButtonDisabled"
          @click="enabledFieldsWs({fields: false, button: true})">
          {{$t('Editar')}}
        </b-button>
        <b-button
          v-else
          :variant="buttonSaved.variant"
          class="btn btn-custom-ws ml-1"
          :disabled="disabledFields.saveButtonDisabled"
          @click="handleActionButton()"
        >
            <b-spinner v-if="disabledFields.save" small></b-spinner>
            <span v-else>{{$t(buttonSaved.textButtonSaved)}}</span>
        </b-button>
      </section>
      <gif-whatsApp/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/@core/utils/eventBus'
import GifWhatsApp from './components/GifWhatsApp.vue'
export default {
  props: {
    onlyRequest: {
      type: Boolean,
      default: false
    }
  },
  components: {
    GifWhatsApp
  },
  data () {
    return {
      disabled: {
        loading: true,
        save: false,
        fields: false
      },
      form: {
        notificationsActive: [],
        selectIncidentNotifications: []
      },
      listNotifications: [
        { text: 'Listo para despacho', value: 'five', disabled: false},
        { text: 'En planta origen', value: 'six', disabled: false },
        { text: 'En reparto', value: 'nine', disabled: false },
        { text: 'Entregado', value: 'ten', disabled: false },
        { text: 'Disponible para retiro', value: 'eleven', disabled: false },
        { text: 'Envío no pudo ser entregado - no hay quien reciba', value: 'nineteen', disabled: false },
        { text: 'Listo para despacho impreso', value: 'twentysix', disabled: false }
      ],
      statesOfIncidence: [
        'No hay quien reciba',
        'Destinatario desconocido',
        'Destinatario cambio dirección',
        'Dirección no encontrada',
        'Dirección incorrecta',
        'Envío no pudo ser entregado'
      ],
      activated: false,
      notificationPlanType: 'basic',
      editWhatsApp: false,
      buttonSaved: {
        variant: 'outline-success',
        textButtonSaved: 'Activar'
      }
    }
  },
  watch: {
    'form.notificationsActive': {
      handler(value, prev) {
        if (prev.length > 0 && value.length === 0 && this.form.selectIncidentNotifications.length > 0) {
          const message = `
            <div>
              <p class="text-center">¿Está seguro que desea desmarcar todos los estados de notificación tracking?</p>
              <p class="text-center">Esta acción provocará que se desmarquen también todos los estados de incidencia.</p>
            </div>
          `
          this.$confirm(
            this.$t(message),
            () => this.form.selectIncidentNotifications = [],
            'Desmarcar todos los estados',
            'Si',
            'No',
            false,
            () => this.form.notificationsActive = [...prev]
          )
        }
      },
      deep: true
    },
    whatsapp (value) {
      if (value) {
        this.setForm(value)
        this.disabled.loading = false
      }
    }
  },
  computed: {
    ...mapGetters({
      whatsapp: 'getWhatsApp'
    }),
    disabledFields() {
      const notificationsInactive = this.form.notificationsActive.length === 0
      const baseDisabled = this.disabled.loading || this.disabled.save || this.disabled.fields
      return {
        loading: this.disabled.loading,
        save: this.disabled.save,
        fields: this.disabled.fields,
        notNotificationsActive: notificationsInactive,
        trackingDisabled: baseDisabled,
        incidenceDisabled: baseDisabled || notificationsInactive,
        editButtonDisabled: this.disabled.save || this.disabled.loading,
        saveButtonDisabled: this.disabled.save || this.disabled.loading || (notificationsInactive && !this.form.id)
      }
    }
  },
  created() {
    EventBus.$on('handleDisabledButtonSaved', (value) => {
      this.disabled.save = value
    })
  },
  beforeDestroy() {
    EventBus.$off('handleDisabledButtonSaved')
  },
  mounted () {
    this.handleViewComponent()
  },
  methods: {
    handleViewComponent () {
      if (this.onlyRequest) {
        this.disabled.loading = false
        this.buttonSaved = {
          variant: 'outline-warning',
          textButtonSaved: 'Solicitar'
        }
      } else {
        // Comentando ya que no tiene back
        //this.getWhatsApp()
        // Borrar cuando tenga back
        // Simulando que viene activado
        /* this.setForm({activated: true})
        this.enabledFieldsWs({fields: true, button: false}) */
        // Simulando que viene inactivado
        this.setForm({activated: false})
        this.disabled.loading = false
      }
    },
    getWhatsApp () {
      const params = {
        company_id: this.$route.params.id
      }
      const queryParams = {}
      this.$store.dispatch('fetchService', { name: 'getWhatsApp', params, queryParams})
    },
    setForm (value) {
      this.form = {
        ...this.form,
        ...value
      }
      if (!!value.id) {
        this.form.notificationsActive = Object.keys(value.statuses_tracking)
        this.form.selectIncidentNotifications = Object.keys(value.statuses_incidence)
        this.buttonSaved.textButtonSaved = 'Guardar cambios'
        this.disabled.fields = true
      }
    },
    getStatusClass(activated) {
      return activated ? 'table_dot--ws-ok' : 'table_dot--ws-inactivated'
    },
    enabledFieldsWs ({fields, button}) {
      this.disabled.fields = fields
      this.editWhatsApp = button
    },
    handleActionButton () {
      if (this.onlyRequest) {
        this.disabled.save = true
        this.$emit('requestComplementaryProduct')
      } else {
        this.savedWhastApp()
      }
    },
    savedWhastApp () {
      this.disabled.save = true
      const params = {
        company_id: this.$route.params.id
      }
      const queryParams = {
        ...this.form
      }
      const services = this.form?.id ? 'editWhatsApp' : 'activeWhatsApp'
      this.$store.dispatch('fetchService', { name: services, params, queryParams, hideAlert: true, onSuccess: (resp) => this.onSuccessWhatsApp(resp.data), onError: (e) => { this.onErrorWhatsApp(e) }})
    },
    onSuccessWhatsApp (result) {
      const message = this.form?.id ? 'msg-exito-editar-ws' : 'msg-exito-activar-ws'
      this.$newSuccess('Excelente', this.$t(message))
      this.setForm(result)
      this.disabled.save = false
      this.enabledFieldsWs({fields: true, button: false})
    },
    onErrorWhatsApp (e) {
      this.disabled.save = false
      this.$newError('Ocurrio un error.', e.message)
    }
  }
}
</script>
<style>
.container-ws {
  display: grid;
  grid-template-columns: 70% 30%;
}
.table_dot--ws{
  position: relative;
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
}
.table_dot--ws-ok{
  background-color:#5CB30B
}
.table_dot--ws-inactivated{
  background-color:#D1DADE
}
.vertical-line {
  width: 1px;
  background-color: #B9B9B9;
}
.custom-color-text-ws{
  color: #6E6B7B;
  font-weight: 300;
}
.btn-custom-ws{
  padding: 0.786rem 5rem;
}
.img-responsive img {
   max-width: 100%;
}
.alert-customize-ws{
  color: #31AEE4;
}
.custom-button-gif-ws {
    margin: 0;
    font-size: 11px;
    padding: 0.5rem 1.5rem;
    font-weight: bold;
}
.custom-button-gif-ws-left {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 20px !important;
    border-bottom-right-radius: 0 !important;
}
.custom-button-gif-ws-right {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 20px !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 20px !important;
}
.opacity-statuses-incidence {
  opacity: 0.6;
}
.custom-disabled-field-ws .custom-control-input:disabled ~ .custom-control-label::before,
.custom-disabled-field-ws .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #fff;
  border: #d8d6de solid 1px;
}
.gif-image {
  width: initial !important;
}
@media (max-width: 768px) {
    .container-ws {
        grid-template-columns: 1fr;
        grid-template-rows: auto auto;
    }
    .container-statuses {
        flex-direction: column;
    }
}
</style>